exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".voice-recording-consent-container{margin:-10px auto 40px;font-size:14px;color:#4a4a4a;width:100%;text-align:center}", ""]);

// exports
